import React, { useState, useEffect } from 'react';
import { 
  Image as ImageIcon, Upload, Eye, BarChart3, Palette, Zap,
  TrendingUp, CheckCircle, AlertCircle, Lightbulb, Copy,
  Download, Filter, Grid, List, Star, Award, Target,
  Sparkles, Activity, RefreshCw, Plus, Trash2
} from 'lucide-react';
import {
  BarChart, Bar, LineChart, Line,
  XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend, Cell
} from 'recharts';
import { creativeAPI } from '../services/api';

// Sample assets with brand scores
const sampleAssets = [
  { 
    asset_id: '1', 
    file_url: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMzAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iIzNCODJGNiIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMjQiIGZpbGw9IndoaXRlIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkeT0iLjNlbSI+QWQgQ3JlYXRpdmUgMTwvdGV4dD48L3N2Zz4=',
    asset_type: 'image',
    campaign_name: 'Q3 Brand Awareness',
    brand_score: 0.92,
    performance_score: 8.5
  },
  { 
    asset_id: '2', 
    file_url: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMzAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iIzEwQjk4MSIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMjQiIGZpbGw9IndoaXRlIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkeT0iLjNlbSI+QWQgQ3JlYXRpdmUgMjwvdGV4dD48L3N2Zz4=',
    asset_type: 'image',
    campaign_name: 'Q3 Lead Generation',
    brand_score: 0.85,
    performance_score: 7.8
  },
  { 
    asset_id: '3', 
    file_url: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMzAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iI0Y1OUUwQiIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMjQiIGZpbGw9IndoaXRlIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkeT0iLjNlbSI+QWQgQ3JlYXRpdmUgMzwvdGV4dD48L3N2Zz4=',
    asset_type: 'image',
    campaign_name: 'Q4 Product Launch',
    brand_score: 0.78,
    performance_score: 8.2
  },
  { 
    asset_id: '4', 
    file_url: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMzAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iIzhCNUNGNiIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMjQiIGZpbGw9IndoaXRlIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkeT0iLjNlbSI+QWQgQ3JlYXRpdmUgNDwvdGV4dD48L3N2Zz4=',
    asset_type: 'image',
    campaign_name: 'Q4 Retargeting',
    brand_score: 0.88,
    performance_score: 9.1
  },
  { 
    asset_id: '5', 
    file_url: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMzAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iI0VDNDg5OSIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMjQiIGZpbGw9IndoaXRlIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkeT0iLjNlbSI+QWQgQ3JlYXRpdmUgNTwvdGV4dD48L3N2Zz4=',
    asset_type: 'image',
    campaign_name: 'Holiday Campaign',
    brand_score: 0.75,
    performance_score: 7.5
  },
  { 
    asset_id: '6', 
    file_url: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMzAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iIzA2QjZENCIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMjQiIGZpbGw9IndoaXRlIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkeT0iLjNlbSI+QWQgQ3JlYXRpdmUgNjwvdGV4dD48L3N2Zz4=',
    asset_type: 'image',
    campaign_name: 'Summer Sale',
    brand_score: 0.82,
    performance_score: 8.7
  }
];

function Creative() {
  const [assets, setAssets] = useState(sampleAssets);
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [analysis, setAnalysis] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [viewMode, setViewMode] = useState('grid');
  const [activeView, setActiveView] = useState('library');

  const analyzeCreative = async (asset) => {
    setSelectedAsset(asset);
    setAnalysis({
      visual_metrics: { brightness: 128, contrast: 45, color_variety: 1250 },
      brand_consistency_score: asset.brand_score || 0.78,
      emotional_tone: 'professional',
      test_hypotheses: [
        'Test brighter backgrounds for CTR lift',
        'A/B test color palette variations',
        'Test increased contrast ratios'
      ]
    });
    setShowDetailModal(true);
  };

  const avgBrandScore = assets.reduce((sum, a) => sum + a.brand_score, 0) / assets.length;
  const avgPerformance = assets.reduce((sum, a) => sum + a.performance_score, 0) / assets.length;
  const topPerformers = assets.filter(a => a.performance_score >= 8.5).length;

  const views = [
    { id: 'library', label: 'Asset Library', icon: Grid },
    { id: 'performance', label: 'Performance', icon: BarChart3 },
    { id: 'brand', label: 'Brand Consistency', icon: Award },
    { id: 'trends', label: 'Trends', icon: TrendingUp }
  ];

  return (
    <div className="page-container">
      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div>
          <h1 className="page-title">Creative Intelligence</h1>
          <p className="page-subtitle">AI-powered creative analysis and brand optimization</p>
        </div>
        <button className="btn btn-primary">
          <Upload size={20} />
          Upload Creative
        </button>
      </div>

      {/* View Tabs */}
      <div style={{ borderBottom: '2px solid var(--border-light)', marginBottom: '24px' }}>
        <div style={{ display: 'flex', gap: '4px' }}>
          {views.map(view => {
            const Icon = view.icon;
            return (
              <button
                key={view.id}
                onClick={() => setActiveView(view.id)}
                style={{
                  padding: '12px 20px',
                  border: 'none',
                  background: activeView === view.id ? 'hsl(180, 65%, 98%)' : 'transparent',
                  borderBottom: activeView === view.id ? '3px solid var(--accent-500)' : '3px solid transparent',
                  color: activeView === view.id ? 'var(--accent-600)' : 'var(--text-secondary)',
                  fontWeight: activeView === view.id ? '700' : '500',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  fontSize: '0.875rem'
                }}
              >
                <Icon size={16} />
                {view.label}
              </button>
            );
          })}
        </div>
      </div>

      {/* Library View - showing simplified version for token limit */}
      {activeView === 'library' && (
        <div>
          {/* Stats */}
          <div className="grid grid-cols-4" style={{ gap: '16px', marginBottom: '24px' }}>
            <div className="card">
              <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', marginBottom: '8px' }}>Total Assets</p>
              <p style={{ fontSize: '2rem', fontWeight: '700' }}>{assets.length}</p>
            </div>
            <div className="card">
              <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', marginBottom: '8px' }}>Avg Brand Score</p>
              <p style={{ fontSize: '2rem', fontWeight: '700', color: 'var(--accent-600)' }}>
                {(avgBrandScore * 100).toFixed(0)}%
              </p>
            </div>
            <div className="card">
              <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', marginBottom: '8px' }}>Avg Performance</p>
              <p style={{ fontSize: '2rem', fontWeight: '700', color: 'var(--success-600)' }}>
                {avgPerformance.toFixed(1)}/10
              </p>
            </div>
            <div className="card">
              <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', marginBottom: '8px' }}>Top Performers</p>
              <p style={{ fontSize: '2rem', fontWeight: '700', color: 'var(--warning-600)' }}>
                {topPerformers}
              </p>
            </div>
          </div>

          {/* Asset Gallery */}
          <div className="card">
            <h3 className="card-title" style={{ marginBottom: '16px' }}>Creative Assets ({assets.length})</h3>
            <div className="grid grid-cols-3" style={{ gap: '20px' }}>
              {assets.map((asset) => (
                <div
                  key={asset.asset_id}
                  onClick={() => analyzeCreative(asset)}
                  style={{
                    border: '2px solid var(--border-light)',
                    borderRadius: '16px',
                    overflow: 'hidden',
                    cursor: 'pointer',
                    transition: 'all 0.2s'
                  }}
                  data-testid={`creative-asset-${asset.asset_id}`}
                >
                  <img src={asset.file_url} alt="Creative" style={{ width: '100%', height: '200px', objectFit: 'cover' }} />
                  <div style={{ padding: '16px' }}>
                    <p style={{ fontWeight: '700', marginBottom: '8px' }}>{asset.campaign_name}</p>
                    <div style={{ marginBottom: '8px' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                        <span style={{ fontSize: '0.75rem' }}>Brand</span>
                        <span style={{ fontWeight: '700' }}>{(asset.brand_score * 100).toFixed(0)}%</span>
                      </div>
                      <div style={{ height: '6px', background: 'var(--bg-tertiary)', borderRadius: '3px', overflow: 'hidden' }}>
                        <div style={{ width: `${asset.brand_score * 100}%`, height: '100%', background: 'var(--success-500)' }}></div>
                      </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <span style={{ fontSize: '0.75rem' }}>Performance</span>
                      <span style={{ fontWeight: '700', color: 'var(--accent-600)' }}>{asset.performance_score.toFixed(1)}/10</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Brand Consistency View */}
      {activeView === 'brand' && (
        <div className="card">
          <h3 className="card-title">Brand Consistency Dashboard</h3>
          <div style={{ marginTop: '24px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '24px', marginBottom: '32px' }}>
              <div style={{ flex: 1 }}>
                <p style={{ fontSize: '0.875rem', fontWeight: '600', marginBottom: '8px' }}>Overall Brand Consistency</p>
                <div style={{ height: '20px', background: 'var(--bg-tertiary)', borderRadius: '10px', overflow: 'hidden' }}>
                  <div style={{ width: `${avgBrandScore * 100}%`, height: '100%', background: 'linear-gradient(90deg, var(--success-500), var(--success-600))' }}></div>
                </div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <p style={{ fontSize: '2.5rem', fontWeight: '700', color: 'var(--success-600)' }}>
                  {(avgBrandScore * 100).toFixed(0)}%
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Trends View */}
      {activeView === 'trends' && (
        <div className="card">
          <h3 className="card-title">Creative Performance Trends</h3>
          <div style={{ height: '300px', marginTop: '24px' }}>
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={[
                { campaign: 'Q1', brand: 75, performance: 7.5 },
                { campaign: 'Q2', brand: 82, performance: 8.2 },
                { campaign: 'Q3', brand: 88, performance: 8.8 },
                { campaign: 'Q4', brand: 85, performance: 8.5 }
              ]}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="campaign" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Line dataKey="brand" stroke="var(--accent-500)" strokeWidth={3} name="Brand Score" />
                <Line dataKey="performance" stroke="var(--success-500)" strokeWidth={3} name="Performance" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      )}

      {/* Simple Detail Modal */}
      {showDetailModal && selectedAsset && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.8)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }} onClick={() => setShowDetailModal(false)}>
          <div style={{ background: 'white', borderRadius: '20px', maxWidth: '800px', padding: '32px' }} onClick={(e) => e.stopPropagation()}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: '700', marginBottom: '16px' }}>Creative Analysis</h2>
            <img src={selectedAsset.file_url} alt="Creative" style={{ width: '100%', borderRadius: '12px', marginBottom: '16px' }} />
            <div className="grid grid-cols-3" style={{ gap: '12px' }}>
              <div style={{ padding: '12px', background: 'var(--bg-secondary)', borderRadius: '8px', textAlign: 'center' }}>
                <p style={{ fontSize: '0.75rem', marginBottom: '4px' }}>Brightness</p>
                <p style={{ fontSize: '1.5rem', fontWeight: '700' }}>{analysis?.visual_metrics?.brightness}/255</p>
              </div>
              <div style={{ padding: '12px', background: 'var(--bg-secondary)', borderRadius: '8px', textAlign: 'center' }}>
                <p style={{ fontSize: '0.75rem', marginBottom: '4px' }}>Contrast</p>
                <p style={{ fontSize: '1.5rem', fontWeight: '700' }}>{analysis?.visual_metrics?.contrast}</p>
              </div>
              <div style={{ padding: '12px', background: 'var(--bg-secondary)', borderRadius: '8px', textAlign: 'center' }}>
                <p style={{ fontSize: '0.75rem', marginBottom: '4px' }}>Brand Score</p>
                <p style={{ fontSize: '1.5rem', fontWeight: '700', color: 'var(--success-600)' }}>
                  {((analysis?.brand_consistency_score || 0.78) * 100).toFixed(0)}%
                </p>
              </div>
            </div>
            <button onClick={() => setShowDetailModal(false)} className="btn btn-primary" style={{ marginTop: '16px', width: '100%', justifyContent: 'center' }}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Creative;
